export default __webpack_public_path__ + "media/images/show_header-warning-37392b4c02d06b0452cf452aa4d39d83.png";